var _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryMassage = function SvgCategoryMassage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 21,
    r: 14,
    fill: "#FBE0CF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.333,
    cy: 39.667,
    r: 9.333,
    fill: "#FBE0CF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.667,
    cy: 44.333,
    r: 2.333,
    fill: "#FBE0CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7A292C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M37.805 21.47a1.95 1.95 0 0 1 .108-2.134l.595-.806c1.386-1.876.045-4.53-2.29-4.53H19.272c-2.334 0-3.676 2.654-2.29 4.53l.595.806c.46.624.496 1.463.108 2.133-.913 1.577-2.54 4.545-3.264 6.86-.68 2.17-.937 4.94-1.002 7.467-.07 2.71 1.5 4.969 3.776 6.093m22.623-16.631c.495 1.039.951 2.11 1.252 3.07.68 2.17.936 4.942 1.002 7.468.1 3.897-3.192 6.861-7.094 6.861H22.28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7A292C",
    strokeWidth: 1.3,
    d: "M23.501 28.735c1.956-3.147 6.536-3.147 8.492 0l1.628 2.618c2.071 3.33-.324 7.64-4.246 7.64h-3.256c-3.921 0-6.317-4.31-4.246-7.64z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7A292C",
    strokeWidth: 1.3,
    d: "M27.645 31.77a.2.2 0 0 1 .346 0l1.345 2.33c.675 1.168-.169 2.628-1.518 2.628s-2.192-1.46-1.518-2.629z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7A292C",
    d: "M20.552 42.65a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0M39.65 23.35a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0"
  })));
};
export default SvgCategoryMassage;